import { render } from "./NavBarItemLabel.vue?vue&type=template&id=5d10a42d"
import script from "./NavBarItemLabel.vue?vue&type=script&lang=js"
export * from "./NavBarItemLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__